import { Variants } from 'framer-motion';

export const animationDurations = {
  fast: 0.15,
  normal: 0.25,
  slow: 0.4,
  slower: 0.6,
} as const;

export const animationDelays = {
  instant: 0,
  fast: 0.05,
  normal: 0.1,
  slow: 0.2,
  slower: 0.3,
} as const;

export const springConfigs = {
  gentle: { type: 'spring', stiffness: 200, damping: 25 },
  bouncy: { type: 'spring', stiffness: 300, damping: 20 },
  smooth: { type: 'spring', stiffness: 100, damping: 20 },
} as const;

export const fadeIn: Variants = {
  hidden: { opacity: 0 },
  visible: { opacity: 1 },
};

export const fadeInUp: Variants = {
  hidden: { opacity: 0, y: 20 },
  visible: { 
    opacity: 1, 
    y: 0,
    transition: {
      duration: animationDurations.normal,
      ease: 'easeOut',
    }
  },
};

export const fadeInDown: Variants = {
  hidden: { opacity: 0, y: -20 },
  visible: { 
    opacity: 1, 
    y: 0,
    transition: {
      duration: animationDurations.normal,
      ease: 'easeOut',
    }
  },
};

export const scaleIn: Variants = {
  hidden: { opacity: 0, scale: 0.95 },
  visible: { 
    opacity: 1, 
    scale: 1,
    transition: {
      duration: animationDurations.normal,
      ease: 'easeOut',
    }
  },
};

export const slideInRight: Variants = {
  hidden: { opacity: 0, x: 20 },
  visible: { 
    opacity: 1, 
    x: 0,
    transition: {
      duration: animationDurations.normal,
      ease: 'easeOut',
    }
  },
};

export const staggerContainer: Variants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: animationDelays.fast,
    }
  },
};

export const staggerItem: Variants = {
  hidden: { opacity: 0, y: 10 },
  visible: { 
    opacity: 1, 
    y: 0,
    transition: {
      duration: animationDurations.fast,
      ease: 'easeOut',
    }
  },
};

export const pageTransition: Variants = {
  initial: { opacity: 0, y: 8 },
  animate: { 
    opacity: 1, 
    y: 0,
    transition: {
      duration: animationDurations.normal,
      ease: 'easeOut',
    }
  },
  exit: { 
    opacity: 0, 
    y: -8,
    transition: {
      duration: animationDurations.fast,
      ease: 'easeIn',
    }
  },
};

export const pulse = {
  scale: [1, 1.05, 1],
  transition: {
    duration: 2,
    repeat: Infinity,
    ease: 'easeInOut',
  },
};

export const shimmer = {
  backgroundPosition: ['200% 0', '-200% 0'],
  transition: {
    duration: 1.5,
    repeat: Infinity,
    ease: 'linear',
  },
};

export default {
  durations: animationDurations,
  delays: animationDelays,
  spring: springConfigs,
  fadeIn,
  fadeInUp,
  fadeInDown,
  scaleIn,
  slideInRight,
  staggerContainer,
  staggerItem,
  pageTransition,
  pulse,
  shimmer,
};
